<template>
  <div>
    <div class="row">
      <div class="col-12 text-center">
        <br />
        <h5>
          <unicon name="envelope-alt" :fill="secCol" style="margin-right: 8px;">
          </unicon>
          <span class="text-barlow-condensed">{{ $t("messages") }}</span>
        </h5>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <button class="button default px-5" @click="toggleComposeModal(true)">
          <span class="">Redactar</span>
          <unicon class="redaction-icon" :name="'message'" :fill="secCol" />
        </button>
      </div>
    </div>
    <div class="bootstrap-wrapper">
      <div class="container pt-3">
        <div class="row pointer" v-for="(msg, i) in messages" :key="i">
          <router-link :to="msg.link" v-slot="{ href, route, navigate }">
            <div class="col-12 row my-2" :href="href" @click="navigate">
              <div class="col-10 text-gray">
                <unicon :name="msg.icon" :fill="secCol" class="mx-2" />
                <span>{{ $t(msg.type) }}</span>
              </div>
              <div class="col-2 text-center text-white">
                <span class="px-1 py-1 not-read" v-if="msg.number">
                  {{ msg.number }}
                </span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "MessagesMenu",
  data() {
    let { secCol } = this.$store.getters;

    return {
      secCol,
      messages: [
        {
          type: "inbox",
          number: 0,
          link: "/dashboard/messages",
          icon: "envelopes",
        },
        // {
        //   type: "dratf",
        //   number: 1,
        //   link: "/dashboard/messages/dratf",
        //   icon: "edit"
        // },
        {
          type: "sentMail",
          number: 0,
          link: "/dashboard/messages/sentMail",
          icon: "envelope-open",
        },
        // {
        //   type: "trash",
        //   number: 0,
        //   link: "/dashboard/messages/trash",
        //   icon: "trash-alt",
        // },
      ],
    };
  },
  methods: {
    ...mapMutations(["toggleComposeModal"]),
  },
};
</script>

<style lang="scss" scoped>
.not-read {
  background-color: var(--color-secondary);
  border-radius: 3px !important;
}

img {
  min-width: 26px;
  min-height: 26px;
}

.redaction-icon {
  position: absolute;
  margin-left: 8px;
  top: 7px;
}
</style>
